import { generateRequestHeadersPageable } from 'src/adminPanel/utils/helperClasses';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import callApi, { CallApiResult } from '.';

export const fetchAllLandingpages = (pageable: PageableQueryParams = {}): Promise<CallApiResult> => {
    return callApi(`/api/admin/landingPage/getAll`, { headers: generateRequestHeadersPageable(pageable) });
};
